(function () {
    "use strict";
    angular.module("atheer.services").factory("Job", Job);

    /* @ngInject */
    function Job($resource) {
        var resourceUrl = "api/jobs";

        return $resource(
            resourceUrl,
            {
                id: "@id",
            },
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );
    }
})();
